export default (fitVidsLoaderFunction = null) => jQuery(($) => {
	$(".av-placeholder__activator[data-iframe-markup]").click(function(){
		var iframe = $($(this).data("iframe-markup"));
		iframe.insertAfter($(this));
		$(this).remove();

		$('.av-placeholder').addClass('av-placeholder__swapped');

		if (fitVidsLoaderFunction) {
			fitVidsLoaderFunction(true);
		}
	});
});
